import { Component, Prop } from '@stencil/core';

/**
 * @description A horizontal narrow or patterned line
 * @use
 * @since 4.0.0
 * @version 3
 */
@Component({
  tag: 'hp6-horizontal-rule',
  styleUrl: 'horizontal-rule.scss',
  shadow: true,
})
export class HorizontalRule {
  /**
   * The type of horizontal rule to be displayed.
   */
  @Prop({ reflect: true }) styleSelection: 'basic' | 'pattern' | 'pattern-alt-1' = 'basic';
}
